<script> 
import forminput from "@/router/views/formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue"; 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlphaziryanitlar from "@/models/tlphaziryanitlar"; 
import useVuelidate from "@vuelidate/core";
export default {
  mixins: [Api, Sabit, tlphaziryanitlar],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
    };
  },
  components: {
    forminput,
    formtextarea, 
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) { 
        if (this.AddEdit == "Add") {
          this.Post("tlphaziryanitlar", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.tlphaziryanitlarData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("tlphaziryanitlar", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.tlphaziryanitlarData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <b-modal
    v-model="ModalOpen"
    id="tlphaziryanitlar"
    size="lg"
    :title="
      this.AddEdit == 'Edit'
        ? 'Kayıt Düzenle'
        : 'Yeni Kayıt Ekle'
    "
    title-class="font-18"
    hide-footer
  >
    <Form @submit.prevent="onSubmit" v-if="FormData">  
      
      <forminput
        :FormDataType="FormDataType.Baslik"
        :Value="FormData.Baslik"
        :v="v$.FormData.Baslik"
        @input="FormData.Baslik = $event.target.value"
      />
      <formtextarea
        :FormDataType="FormDataType.Metin"
        :Value="FormData.Metin"
        :v="v$.FormData.Metin"
        @input="FormData.Metin = $event.target.value"
      />
     
      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
